import { QueryClient } from "@tanstack/react-query";

/** Workspace modules: keep data warm across longer idle gaps in the same tab. */
export const WORKSPACE_QUERY_OPTIONS = {
    staleTime: 5 * 60_000,
    gcTime: 60 * 60_000,
    refetchOnWindowFocus: false,
    retry: 1,
} as const;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: WORKSPACE_QUERY_OPTIONS,
    },
});
